import { Sparkles, X } from "lucide-react";

const SEEDANCE_HREF =
  "https://app.pixro.ai/videos?op=ai-videos&model=seedance-2.5&variation=reference-to-video";

interface AnnouncementBannerProps {
  onDismiss: () => void;
}

const AnnouncementBanner = ({ onDismiss }: AnnouncementBannerProps) => {
  return (
    <div className="fixed top-0 left-0 right-0 z-[60] h-10 overflow-hidden bg-gradient-to-r from-primary via-primary to-emerald-400 text-primary-foreground shadow-[0_1px_12px_-2px_hsl(var(--primary)/0.6)]">
      <div className="relative container mx-auto flex h-full items-center justify-center gap-2 px-10 sm:px-12">
        <a
          href={SEEDANCE_HREF}
          className="group flex items-center gap-1.5 text-xs font-semibold tracking-tight sm:text-sm"
        >
          {/* <Sparkles size={14} className="shrink-0 animate-pulse" /> */}
          <span className="hidden rounded-full bg-primary-foreground/15 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider sm:inline">
            New
          </span>
          <span className="truncate">Seedance 2.5 is live on Pixro</span>
          <span className="underline underline-offset-2 decoration-2 decoration-primary-foreground group-hover:opacity-80 font-bold">
            Try Now
          </span>
        </a>
        <button
          type="button"
          aria-label="Dismiss announcement"
          onClick={onDismiss}
          className="absolute right-3 sm:right-4 flex items-center justify-center rounded-full p-1 text-primary-foreground/80 transition-colors hover:bg-primary-foreground/10 hover:text-primary-foreground"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
